<template>

  <div>
    <div class="main-content container-fluid">
      <div class="row">
        <div class="col-md-12">
          <PageHeader title="Manage Ads" subtitle="">
            <button v-on:click="openCreateModal" data-toggle="modal" data-target="#createModal" slot="top" class="btn btn-primary" style="float: right;margin-top:10px;">
              <i class="icon mdi mdi-plus"></i> &nbsp;Create Ad
            </button>
            <div class="clearfix"></div>
          </PageHeader>

          <Panel class="panel panel-default panel-border-color panel-border-color-primary">

            <div class="filters">
              <div class="row">
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm row">
                    <label class="col-form-label col-xs-4 control-label">Status</label>
                    <div class="col-xs-8">
                      <select v-model="selectedStatus" class="form-control">
                        <option v-for="option in statusFilters" v-bind:value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm row">
                    <label class="col-form-label col-xs-4 control-label">Company</label>
                    <div class="col-xs-8">
                      <select v-model="selectedCompany" class="form-control">
                        <option v-for="option in companyFilters" v-bind:value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm row">
                    <label class="col-form-label col-xs-4 control-label">Page</label>
                    <div class="col-xs-8">
                      <select v-model="selectedPage" class="form-control">
                        <option v-for="option in pageFilters" v-bind:value="option">
                          {{ option }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-xs-12 col-sm-6 col-md-3">
                  <div class="form-group form-group-sm">
                    <input type="text" class="form-control" placeholder="Search title..." v-model="searchTerm" />
                  </div>
                </div>
              </div>
            </div>

            <DynamicTable :data="filteredData" :fields="fields" :onClick="editRecord" :defaultSort="'title'">

            </DynamicTable>

            <div class="settings-container">

            </div><!-- /.main-content -->
          </Panel>
        </div><!-- /div -->
      </div><!-- /div -->
    </div><!-- /div -->



    <!-- Modal -->
    <div class="modal fade" id="createModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">Ad details</h3>
          </div>
          <div class="modal-body" v-if="selectedAd">

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtTitle">Title</label>
                  <div class="col-xs-8">
                    <input type="text" id="txtTitle" class="form-control" v-model="selectedAd.title" />
                  </div>
                </div>
              </div><!-- /.col -->
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtUrl">Link URL</label>
                  <div class="col-xs-8">
                    <input type="text" id="txtUrl" class="form-control" v-model="selectedAd.url" />
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtCompany">New Company</label>
                  <div class="col-xs-8">
                    <input type="text" id="txtCompany" class="form-control" v-model="selectedAd.company" />
                  </div>
                </div>
              </div><!-- /.col -->
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="ddlCompany">Or existing</label>
                  <div class="col-xs-8">
                    <select v-model="companySelect" v-on:change="companyChanged" id="ddlCompany" class="form-control">
                      <option v-for="option in companyFilters">
                        {{option}}
                      </option>
                    </select>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtStart">Start Date</label>
                  <div class="col-xs-8">
                    <datepicker v-model="selectedAd.start" format="yyyy-MM-dd" name="startDate" input-class="form-control" :disabled-dates="disabledDates"></datepicker>
                  </div>
                </div>
              </div><!-- /.col -->
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtEnd">End Date</label>
                  <div class="col-xs-8">
                    <datepicker v-model="selectedAd.end" format="yyyy-MM-dd" name="endDate" input-class="form-control" :disabled-dates="disabledDates"></datepicker>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtPage">Display Page</label>
                  <div class="col-xs-8">
                    <select v-model="selectedAd.displayPage" id="txtPage" class="form-control">
                      <option v-for="option in pageFilters">
                        {{option}}
                      </option>
                    </select>
                  </div>
                </div>
              </div><!-- /.col -->
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtSlot">Slot ID</label>
                  <div class="col-xs-8">
                    <input type="number" min="1" id="txtSlot" class="form-control" v-model="selectedAd.slotID" />
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div class="setting form-group row form-group-sm">
                  <label class="col-xs-4 col-form-label" for="txtStatus">Status</label>
                  <div class="col-xs-8">
                    <select v-model="selectedAd.status"  id="txtStatus"  class="form-control">
                      <option v-for="option in statusFilters">
                        {{option}}
                      </option>
                    </select>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <hr />

            <p>
              <strong>Suggested size (px):</strong> {{imageSize}} - <a href="https://support.google.com/adsense/answer/6002621?hl=en" target="_blank">More info</a>
            </p>

            <div class="row">
              <div class="col-xs-12">
                <div class="setting form-group row form-group-sm">
                  <div class="col-xs-12 col-sm-3 col-form-label">
                    <strong>Select image</strong>
                    
                  </div>
                  <div class="col-xs-12 col-sm-9">
                    <input type="file" v-on:change="imageAdded" name="image">
                    <div class="loading" v-if="imageLoading">
                      <LoadingIndicator></LoadingIndicator>
                    </div>
                    <div class="image-preview">
                      <img :src="selectedAd.image" />
                    </div>
                  </div>
                </div>
              </div><!-- /.col -->
            </div>

            <div class="alert alert-danger" v-if="errors.length > 0">
              Please correct the following errors:
              <ul>
                <li v-for="e in errors">{{e}}</li>
              </ul>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-danger pull-left" v-on:click="deleteAd" v-if="selectedAd && selectedAd.id">Delete</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="save" :disabled="imageLoading">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div><!-- /div -->

</template>

<script>

  import { mapState, mapActions, mapGetters } from 'vuex';
  import Ad from '../../../resources/ad'
  import _ from 'underscore'
  import Datepicker from 'vuejs-datepicker';
  import Dropzone from '../../vue2-dropzone/src/index'



  export default {
    components: {
      Datepicker,
      Dropzone
    },

    created() {
      this.$store.dispatch('getAds');
    },

    methods: {

      openCreateModal() {
        this.selectedAd = Object.assign({}, this.adTemplate);
      },

      editRecord: function (id) {
        const ad = _.find(this.ads, function (d) { return d.id === id });
        if (ad) {
          this.selectedAd = Object.assign({}, ad);
          $('#createModal').modal();
        }
      },

      imageAdded($event) {
        this.selectedImage = $event.target.files[0]
        //validate the image
        if (!this.validate(this.selectedImage))
          return
        // create a form
        let form = new FormData();
        form.append('file', this.selectedImage);

        this.imageLoading = true;

        $.ajax(Object.assign({}, this.fileUploadOptions, {data: form}))
        .then(this.createImage)
        .catch(this.onImageError);
      },

      onImageError(err){
          Toast.error(err);
          this.imageLoading = false;
        },

      validate(image) {
        if(image) {
          if (!this.allowableTypes.includes(image.name.split(".").pop().toLowerCase())) {
            Toast.error(`Sorry you can only upload ${this.allowableTypes.join("|").toUpperCase()} files.`)
            return false
          }

          if (image.size > this.maximumSize){
            Toast.error("File size must not exceed 5 Mb")
            return false
          }
        }
        return true
      },

      createImage() {
        this.imageLoading = false;
        if(this.selectedImage) {
          const image = new Image()
          const reader = new FileReader()
          reader.onload = (e) => {
            this.selectedAd.image = e.target.result
            this.$forceUpdate()
          };
          reader.readAsDataURL(this.selectedImage)
        }
      },

      save() {
        if(this.imageLoading) {
          Toast.error("Please wait for image to finish loading");
          return;
        }

        if(!this.isValid()) {
          return;
        }

        const _this = this;

        if (this.selectedAd.id > 0) {
          const changes = {
            start: this.selectedAd.start,
            end: this.selectedAd.end,
            company: this.selectedAd.company,
            status: this.selectedAd.status,
            slotID: this.selectedAd.slotID,
            displayPage: this.selectedAd.displayPage,
            title: this.selectedAd.title,
            url: this.selectedAd.url
          };

          if(this.selectedAd.image.startsWith('data')) {
            console.log('updating image');
            changes.image = this.selectedAd.image;
          }
          this.$store.dispatch('updateAd', { id: this.selectedAd.id, changes }).then(() => {
          });
        } else {
          this.$store.dispatch('createAd', { ad: this.selectedAd }).then(() => {
          });
        }
        $('#createModal').modal('hide');
      },

      isValid() {
        this.errors = [];
        if(new Date(this.selectedAd.start) > new Date(this.selectedAd.end)) {
          this.errors.push('Start date must be before end date');
        }

        if(!this.selectedAd.company) {
          this.errors.push('Company is a required field');
        }

        if(!this.selectedAd.title) {
          this.errors.push('Title is a required field');
        }

        if(!this.selectedAd.url) {
          this.errors.push('URL is a required field');
        }

        if(!this.selectedAd.image) {
          this.errors.push('Must select an image');
        }

        if(!this.selectedAd.status) {
          this.errors.push('Status is a required field');
        }

        if(!this.selectedAd.displayPage) {
          this.errors.push('Display page is a required field');
        }

        return this.errors.length <= 0;
      },

      deleteAd() {
        const ad = this.selectedAd;

        if( !confirm(`Are you sure you want to delete '${ad.title}?'`)) return;
        this.$store.dispatch('deleteAd', { ad });

        $('#createModal').modal('hide');
      },

      refreshFilters(ads) {
        for (let i = 0; i < ads.length; i++) {
          var ad = ads[i];

          if (_.every(this.companyFilters, function (a) { return a !== ad.company })) {
            this.companyFilters.push(ad.company);
          }
        }
      },
      companyChanged() {
        this.selectedAd.company = this.companySelect;
      }
    },

    computed: {
      ...mapState([
        'currentUser',
      ]),

      ads() {
        const ads = this.$store.getters.allAds;
        this.refreshFilters(ads);
        return ads;
      },

      filteredData() {
        let f = {};

        if (this.selectedStatus) {
          f.status = this.selectedStatus;
        }
        if (this.selectedCompany) {
          f.company = this.selectedCompany;
        }
        if (this.selectedPage) {
          f.displayPage = this.selectedPage;
        }

        var filtered = _.where(this.ads, f);

        if (this.searchTerm) {
          var searched = [];
          for (let i = 0; i < filtered.length; i++) {
            if (filtered[i].title.toLowerCase().match(this.searchTerm.toLowerCase() + '.*')) {
              searched.push(filtered[i]);
            }
          }

          return searched;
        } else {
          return filtered;
        }
      },

      imageSize() {
        let size = '';
        switch(this.selectedAd.displayPage) {
          case 'public':
            if(this.selectedAd.slotID === 1) {
              size = '728 wide x 90 high';
            } else if(this.selectedAd.slotID >= 2) {
              size = '300 wide x 250 high';
            }
            break;
          case 'dashboard':
            if(this.selectedAd.slotID === 1) {
              size = '728 wide x 90 high';
            } else if(this.selectedAd.slotID === 2) {
              size = '160 wide x 600 high';
            } else if(this.selectedAd.slotID >= 3) {
              size = '300 wide x 250 high';
            }
            break;
          case 'studier':
            if(this.selectedAd.slotID === 1) {
              size = '728 wide x 90 high';
            } else if(this.selectedAd.slotID >= 2) {
              size = '160 wide x 600 high';
            }
            break;
        }

        return size;
      },
    },

    data() {
      return {
        allowableTypes: ['jpg', 'jpeg', 'png', 'gif'],
        maximumSize: 5000000,
        selectedImage: null,
        fields: ['title', 'company', 'displayPage', 'slotID', 'start', 'end', 'status'],
        statusFilters: ['', 'active', 'pending', 'expired', 'inactive'],
        companyFilters: [''],
        pageFilters: ['', 'public', 'dashboard', 'studier'],
        disabledDates: {
          to:new Date()
        },
        searchTerm: '',
        selectedStatus: '',
        selectedCompany: '',
        selectedPage: '',
        selectedAd: null,
        errors: [],
        adTemplate: {
          id:null,
          start: new Date(),
          end: new Date().setMonth(new Date().getMonth() + 1),
          company: '',
          status: 'active',
          slotID: 1,
          displayPage: 'dashboard',
          title: 'New ad',
          url: '',
          image: ''
        },
        companySelect: '',
        fileUploadOptions:{
          url: 'https://httpbin.org/post',
          type: "POST",
          processData: false,
          contentType: false
        },
        imageLoading: false
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .filters {padding:10px 10px;}
  .filters label {padding-top:8px;}
  .filters .btn {padding:3px 8px;}
  .filters .form-group {margin-bottom:0px;}

  #adImageUploadDropzone { text-align: center; }

  .loading {margin-top:10px;}
  .image-preview { width: 200px; margin-top: 10px; height:200px; }
  .image-preview img {max-width:100%;max-height:100%;}
</style>



// WEBPACK FOOTER //
// admanager.vue?18e6f5d3